<template>
    <div class="d-flex justify-content-between" :class="no_margin ? '' : 'mt-3 mb-1'"> 
        <h5 class="mb-0">
            <slot name="icon"></slot>
            <a href="#" class="card-link" @click.prevent="$emit('click')" v-if="link">
                {{ title }}
            </a>
            
            <span v-else>
                {{ title }}
            </span>

            <span class="badge" :class="'badge-' + ( badgecolor ? badgecolor : 'secondary' )" v-if="qtd">{{ qtd }}</span>

            <slot name="status"></slot>
        </h5>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ["title", "qtd", "link", "badgecolor", "no_margin"]
}
</script>